import React, { useMemo } from 'react';
import { IconType } from 'react-icons';
import { MdArrowOutward } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import useRem from '../../../hooks/useRem';
import {
    IconWrapper,
    Item,
    ItemSkeleton,
    RelatedItemsContainer,
} from './style';

export type RelatedItemType = {
    id: string;
    title: string;
    description: string;
    img: string;
    value: number;
    productTypeName: string;
    icon: IconType;
};

export const RelatedItem: React.FC<{
    items: RelatedItemType[];
    isLoading: boolean;
}> = ({ items, isLoading }) => {
    const rem = useRem();
    const navigateTo = useNavigate();

    const randomItems = useMemo(() => {
        const shuffled = items.sort(() => 0.5 - Math.random());
        return shuffled.slice(0, 3);
    }, [items]);

    const handleClick = () => {
        navigateTo('/', { viewTransition: true });
        setTimeout(() => {
            const yOffset = -1 * 5 * rem;
            const element = document.getElementById('services-header');
            if (!element) return;
            const y =
                element.getBoundingClientRect().top + window.scrollY + yOffset;

            window.scrollTo({ top: y, behavior: 'smooth' });
        }, 50);
    };

    return (
        <RelatedItemsContainer>
            <h3>Talvez tenha interesse...</h3>

            {isLoading
                ? Array.from({ length: 3 }).map((_, i) => (
                      <ItemSkeleton key={i} />
                  ))
                : randomItems.map(
                      ({ title, icon, description, img }, index) => (
                          <Item key={index} onClick={handleClick}>
                              <div className={'content'}>
                                  <div className={'title'}>
                                      <IconWrapper as={icon} />
                                      <p>{title}</p>
                                  </div>
                                  <div className={'grow'}></div>
                                  <div className={'descriptor'}>
                                      <p title={description}>{description}</p>
                                      <span>
                                          Ver mais
                                          <MdArrowOutward />
                                      </span>
                                  </div>
                              </div>
                              <img src={img} alt={title} />
                          </Item>
                      )
                  )}
        </RelatedItemsContainer>
    );
};
